{
  "el": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "Οι καταγγελίες για spam δεν μπορούν να επανενεργοποιηθούν εδώ. Αυτό γίνεται μόνο χειροκίνητα μέσω {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Αναζήτηση",
      "selected": "Επιλεγμένα"
    }
  }
}
